export default __webpack_public_path__ + "static/media/p-8.c71d29cc.png";